// How often a polled source is listed (`poll_minutes`, 1–1440 in the apps): a preset, or a
// number of minutes typed by the user.
export const CADENCE_PRESETS = [5, 15, 60, 1440] as const;
export type Preset = (typeof CADENCE_PRESETS)[number];

export interface Cadence {
  preset: Preset | "custom";
  /** The minutes typed when `preset` is custom. */
  custom: string;
}

export const MAX_MINUTES = 1440;

/** The minutes to send, or null when the custom value is not a whole number in range. */
export function cadenceMinutes(c: Cadence): number | null {
  if (c.preset !== "custom") return c.preset;
  const text = c.custom.trim();
  if (!/^\d+$/.test(text)) return null;
  const n = Number(text);
  return n >= 1 && n <= MAX_MINUTES ? n : null;
}
